<template>
  <div ref="item" class="item" @click="goDetail">
    <div class="cover-box">
      <img ref="cover" class="cover" :data-src="handleCover(detail.cover)" />
    </div>
    <div class="title">
      {{ detail.title }}
    </div>
    <div class="info">
      <div class="price">
        {{ currency }}&nbsp;{{ handlePrice(detail.price) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import compareVersion from '@/utils/compare-version'
import { appInstall, copyText, Jockeys, imgFilter } from '@/utils'
import { isDuApp, appVersion } from '@/utils/getDevice'
import sensors from '@/plugins/track'

export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      intersectionObserver: null
    }
  },
  computed: {
    ...mapState(['AREA']),
    ...mapGetters(['currency'])
  },
  mounted() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio > 0) {
        this.$refs.cover.src = this.$refs.cover.dataset.src
        this.observerDestroy()
      }
    })
    this.intersectionObserver.observe(this.$refs.item)
  },
  beforeDestroy() {
    this.observerDestroy()
  },
  methods: {
    observerDestroy() {
      this.intersectionObserver && this.intersectionObserver.disconnect()
      this.intersectionObserver = null
    },
    goDetail() {
      if (isDuApp && compareVersion(appVersion, '2.1.5') !== -1) {
        Jockeys.openNativePage('/sell/productDetail', {
          spuId: this.detail.spuId
        })
        this.spuTrack()
        return
      }

      if (isDuApp) {
        const msg = '貨號已複製，暫僅可在首頁粘貼並搜索。'
        copyText(this.detail.itemNo)
        this.$toast(msg)
        this.spuTrack()
        return
      }

      this.spuTrack().then(() => {
        appInstall('/router/sell/productDetail', { spuId: this.detail.spuId })
      })
    },
    handlePrice(price) {
      if (!price) return '--'
      if (this.AREA === 'JP') return price
      return price / 100
    },
    handleCover(url) {
      const newUrl = (url += imgFilter('', 200))
      return newUrl
    },
    spuTrack() {
      return new Promise((resolve) => {
        if (this.$route.path !== '/share/rate-activity') {
          resolve()
          return
        }

        sensors.track(
          'pozion_theme_activity_product_click',
          {
            current_page: 'pozion_theme_activity_product_click_82',
            spu_id: this.detail.spuId,
            activity_title: document.title
          },
          () => {
            resolve()
          }
        )
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// TODO 移到全局依赖
@mixin text-truncate() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@mixin text-truncate-multi($clamp: 3) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: $clamp;
  overflow: hidden;
}

.item {
  padding: 32px 20px 16px;
  background-color: #fff;
}
.cover-box {
  margin-bottom: 40px;
  text-align: center;
}
.cover {
  height: 120px;
}
.title {
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  -webkit-box-align: left;
  height: 64px;
  color: rgb(51, 51, 51);
  font-size: 24px;
  font-family: SFProText-Regular;
  font-weight: normal;
  line-height: 32px;
  @include text-truncate-multi(2);
}
.price {
  color: rgb(51, 51, 51);
  font-size: 30px;
  font-family: HelveticaNeue-CondensedBold;
  font-weight: condensedbold;
  line-height: 40px;
}
</style>
